/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function initQbkSlider() {
    document.querySelectorAll('.qbk-offer-list--transition').forEach(slider => {
      if (slider.closest('.qbk-slider-wrapper')) return;

      const items = Array.from(slider.children);
      if (items.length < 2) return;

      slider.style.overflowX = 'auto';
      slider.style.scrollBehavior = 'smooth';

      const wrapper = document.createElement('div');
      wrapper.className = 'qbk-slider-wrapper';
      slider.parentNode.insertBefore(wrapper, slider);
      wrapper.appendChild(slider);

      const left = document.createElement('button');
      left.type = 'button';
      left.className = 'qbk-slider-arrow left';
      left.innerHTML = '‹';

      const right = document.createElement('button');
      right.type = 'button';
      right.className = 'qbk-slider-arrow right';
      right.innerHTML = '›';

      wrapper.appendChild(left);
      wrapper.appendChild(right);

      const getCardWidth = () =>
        slider.children[0]?.getBoundingClientRect().width || 200;

      right.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        slider.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      };

      left.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        slider.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      };
    });
  }

  initQbkSlider();
  new MutationObserver(initQbkSlider).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {

  const translations = {
    'รับฟรี! เสื้อฮาวาย': 'Get a FREE gift with every order!',
    'ข้อเสนอพิเศษ': 'Special Offer',
    'ซื้อเพิ่มเพื่อรับสินค้าฟรี':
      'Spend more to unlock a FREE gift from our most-loved products!'
  };

  function isEnglish() {
    return (
      document.documentElement.lang &&
      document.documentElement.lang.toLowerCase().startsWith('en')
    );
  }

  function translateText(text) {

    // ✅ 1. แปลประโยคยาวก่อน (สำคัญที่สุด)
    if (translations[text]) {
      return translations[text];
    }

    // ✅ 2. เคสซื้อครบ xxx เลือกของฟรี
    if (text.includes('ซื้อครบ') && text.includes('เลือกสินค้าฟรี')) {
      return text
        .replace('ซื้อครบ', 'Spend')
        .replace('เลือกสินค้าฟรี', 'now and select a FREE GIFT')
        .replace('เสื้อฮาวาย', 'Hawaiian Shirt')
        .replace('ตัว', 'item');
    }

    // ✅ 3. แปลคำเดี่ยว "สินค้า" (แต่ไม่ยุ่งกับ "สินค้าฟรี")
    if (/สินค้า(?!ฟรี)/.test(text)) {
      return text.replace(/สินค้า(?!ฟรี)/g, 'Select');
    }

    return null;
  }

  function updateQikifyTexts() {
    if (!isEnglish()) return;

    document.querySelectorAll('body *').forEach(el => {
      if (el.children.length > 0) return;

      const text = el.textContent.trim();
      if (!text) return;

      const translated = translateText(text);
      if (translated) {
        el.textContent = translated;
      }
    });
  }

  updateQikifyTexts();

  new MutationObserver(updateQikifyTexts).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

})();

(function () {
  const isEN = () => location.pathname.startsWith('/en');
  const root = document.querySelector('#product-builder') || document.body;

  /* ================= MAP ================= */

  const CATEGORY_MAP = {
    'ป้ายชื่อ-นามสกุล ( อกขวา )': 'Name badge (Right chest)',
    'ป้ายชื่อย่อ สังกัด/หน่วยงาน ( อกซ้าย )':
      'Unit / Department abbreviation (Left chest)',
    'ขนาดเสื้อ': 'Shirt size',
    'ขนาดกางเกง': 'Pants size',
    'เครื่องหมายเหล่า ( ปกคอขวา )': 'Branch insignia (Right collar)',
    'เครื่องหมายยศ ( ปกคอซ้าย )': 'Rank insignia (Left collar)',
    'เครื่องหมายความสามารถ ( อกขวา )': 'Skill badge (Right chest)',
    'เครื่องหมายความสามารถ ( อกซ้าย )': 'Skill badge (Left chest)',
    'เครื่องหมายความสามารถ ( อกขวา ) เพิ่มเติมลำดับที่ 2':
      'Skill badge (Right chest) – additional #2',
    'เครื่องหมายความสามารถ ( อกซ้าย ) เพิ่มเติมลำดับที่ 2':
      'Skill badge (Left chest) – additional #2',
    'เงื่อนไขก่อนสั่งซื้อ': 'Conditions before ordering'
  };

  const PLACEHOLDER_MAP = {
    'พิมพ์ ชื่อ-นามสกุล': 'Enter full name',
    'สังกัด/หน่วยงาน': 'Unit / Department'
  };

  /* ================= TRANSLATE ================= */

  function translateCategories() {
    document.querySelectorAll('.cpb-category-title span').forEach(el => {
      const raw = el.textContent.trim();
      const hasStar = raw.startsWith('**');
      const clean = raw.replace(/^\*\*/, '').trim();

      if (isEN() && CATEGORY_MAP[clean]) {
        el.textContent = (hasStar ? '**' : '') + CATEGORY_MAP[clean];
      }

      if (!isEN()) {
        const th = Object.keys(CATEGORY_MAP)
          .find(k => CATEGORY_MAP[k] === clean);
        if (th) el.textContent = (hasStar ? '**' : '') + th;
      }
    });
  }

  function translatePlaceholders() {
    document.querySelectorAll('input[placeholder]').forEach(input => {
      const ph = input.getAttribute('placeholder');

      if (isEN() && PLACEHOLDER_MAP[ph]) {
        input.placeholder = PLACEHOLDER_MAP[ph];
      }

      if (!isEN()) {
        const th = Object.keys(PLACEHOLDER_MAP)
          .find(k => PLACEHOLDER_MAP[k] === ph);
        if (th) input.placeholder = th;
      }
    });
  }

  function translateButtons() {
    document.querySelectorAll('.cpb-reset-button span')
      .forEach(el => el.textContent = isEN() ? 'Reset' : 'รีเซ็ต');

    document.querySelectorAll('.cpb-add-to-cart-button span')
      .forEach(el => el.textContent = isEN() ? 'Add to Cart' : 'เพิ่มลงตะกร้า');
  }

  function translateOptions() {
    document.querySelectorAll('.cpb-option-type-text div, .option-label')
      .forEach(el => {
        const t = el.textContent.trim();

        if (isEN() && (t === 'ไม่ปัก' || t === 'ไม่เลือก')) {
          el.textContent = 'None';
        }

        if (!isEN() && (t === 'None' || t === 'No embroidery')) {
          el.textContent = 'ไม่ปัก';
        }
      });
  }

  function translateCheckbox() {
    document.querySelectorAll('.cpb-checkbox-label-text')
      .forEach(el => {
        if (isEN() && el.textContent.includes('รบกวนตรวจสอบ')) {
          el.textContent =
            'Please review the details carefully before confirming embroidery.';
        }

        if (!isEN() && el.textContent.includes('Please review')) {
          el.textContent =
            'รบกวนตรวจสอบรายละเอียดก่อนยืนยันสั่งปัก';
        }
      });
  }

  function translateQuantity() {
    document.querySelectorAll('.cpb-quantity-label')
      .forEach(el => {
        el.textContent = isEN() ? 'Quantity' : 'จำนวน';
      });
  }

  function runAll() {
    translateCategories();
    translatePlaceholders();
    translateButtons();
    translateOptions();
    translateCheckbox();
    translateQuantity();
  }

  /* ================= INIT ================= */

  runAll();

  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(runAll, 80);
  }).observe(root, {
    childList: true,
    subtree: true
  });

})();




